import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchItemOverviewV1 = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getItemOverviewV1',
    stub: config.useStubbedEndpoints,
  });

  if (!payload.filterOnDespatchTypes) {
    // eslint-disable-next-line max-len
    const getSubClasses = payload && payload.mailCategoriesWithSubClasses && payload.mailCategoriesWithSubClasses.map(element => element.mailSubClasses);
    // eslint-disable-next-line array-callback-return
    const subClass = getSubClasses && getSubClasses.filter(obj => obj.length > 0);
    // eslint-disable-next-line,prefer-destructuring
    const mailSubClassesData = subClass && subClass[0];
    // eslint-disable-next-line no-unused-expressions
    getSubClasses && getSubClasses.forEach((subClasses, index) => {
      if (subClasses.length === 0) {
        // eslint-disable-next-line no-param-reassign
        payload.mailCategoriesWithSubClasses[index].mailSubClasses = mailSubClassesData;
      }
    });
  }

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchItemOverviewV1;
